import { BuscadorNomencladorDiscapacidad } from "../../components/BuscadorNomencladorDiscapacidad"
import { Grid, Button, Card, MenuList, MenuItem, ButtonGroup, Popper, Paper, ClickAwayListener, Grow } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { DescargarPlantillaExcel, SubirArchivoExcel, editarValorizacionDiscapacidad, getValorizacionesDiscapacidad } from "../../../../actions/discapacidad/nomencladorDiscaActions";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import EditConveniosButton from "../../../Contratos/convenios/EditConveniosButton";
import React, { useState } from "react";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

const useStyles = makeStyles({
    botonera: {
        padding: 25
    },
    formControl: {
        marginLeft: 25,
        marginRight: 40,
        minWidth: 150,
    }
});

export const NomencladorDiscapacidad = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { items = [] } = useSelector((state) => state.nomencladorDiscapacidad);

    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [selectedIndex, setSelectedIndex] = React.useState(1);

    const handleEditValorizacion = (idItem, data) => {
        dispatch(editarValorizacionDiscapacidad(idItem, data));
    };

    const handleSearch = (activosPorFecha, discapacidadFiltro, fechaDesde, fechaHasta) => {
        dispatch(getValorizacionesDiscapacidad(discapacidadFiltro === "" ? null : discapacidadFiltro, activosPorFecha,
            fechaDesde, fechaHasta));
    }

    const handleChangeFile = (e) => {
        dispatch(SubirArchivoExcel(e.target.files[0], filtroExcel));
        e.target.value = null;
    };

    const [filtroExcel, setFiltroExcel] = useState(null)
    const downloadFile = () => {
        DescargarPlantillaExcel(dispatch, filtroExcel);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setOpen(false);
    };

    return (
        <>
            <Grid container justify="center">
                <Grid item xs={12}>
                    <ButtonGroup
                        variant="contained"
                        color="inherit"
                        ref={anchorRef}
                        aria-label="split button"
                        style={{
                            boxShadow: "none",
                            width: "100%",
                            justifyContent: "center",
                            marginTop: "1rem",
                        }}
                    >
                        {selectedIndex === 0 && (
                            <>
                                <input
                                    accept="*/*"
                                    style={{ display: "none" }}
                                    id="selectArchivoExcel"
                                    multiple
                                    type="file"
                                    onChange={handleChangeFile}
                                />
                                <Button
                                    component="span"
                                    variant="contained"
                                    color="primary"
                                    startIcon={<CloudUploadIcon />}
                                    style={{ borderRadius: "3px 0px 0px 3px" }}
                                    onClick={() =>
                                        document.querySelector(`#selectArchivoExcel`).click()
                                    }
                                >
                                    Subir Plantilla
                                </Button>
                            </>
                        )}
                        {selectedIndex === 1 && (
                            <Button
                                component="span"
                                variant="contained"
                                color="primary"
                                style={{ borderRadius: "3px 0px 0px 3px" }}
                                startIcon={<CloudDownloadIcon />}
                                onClick={downloadFile}
                            >
                                Descargar Plantilla{" "}
                            </Button>
                        )}
                        <Button
                            color="primary"
                            size="small"
                            aria-controls={open ? "split-button-menu" : undefined}
                            aria-expanded={open ? "true" : undefined}
                            aria-label="select merge strategy"
                            aria-haspopup="menu"
                            onClick={handleToggle}
                        >
                            <ArrowDropDownIcon />
                        </Button>
                    </ButtonGroup>
                    <Popper
                        open={open}
                        anchorEl={anchorRef.current}
                        role={undefined}
                        transition
                        disablePortal
                        style={{ zIndex: 1 }}
                    >
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                style={{
                                    transformOrigin:
                                        placement === "bottom" ? "center top " : "center bottom"
                                }}
                            >
                                <Paper>
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <MenuList id="split-button-menu" >
                                            <MenuItem
                                                selected={0 === selectedIndex}
                                                onClick={(event) => handleMenuItemClick(event, 0)}
                                            >
                                                Subir Plantilla
                                            </MenuItem>
                                            <MenuItem
                                                selected={1 === selectedIndex}
                                                onClick={(event) => handleMenuItemClick(event, 1)}
                                            >
                                                Descargar Plantilla
                                            </MenuItem>
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </Grid>
            </Grid>
            <Grid container justify="center" >
                <Grid item xs={12} md={5} className={classes.root} style={{ marginTop: "1rem" }} >
                    <BuscadorNomencladorDiscapacidad
                        handleSearch={handleSearch}
                        setFiltroExcel={setFiltroExcel}
                    />
                </Grid>
                <Grid item xs={12} md={12} style={{ marginTop: "2rem" }} >
                    <Card>
                        <TableGeneric
                            data={items}
                            columns={[
                                {
                                    label: "Código Práctica",
                                    id: "codigoPractica",
                                },
                                {
                                    label: "Código Integrador",
                                    id: "codigoIntegrador",
                                    customBody: (item) => item.nomencladorIntegrador.codIntegrador
                                },
                                {
                                    label: "Descripción",
                                    id: "modulo",
                                    customBody: (item) => item.nomencladorIntegrador.modulo
                                },
                                {
                                    label: "Categoría",
                                    id: "categoria",
                                    customBody: (item) => item.nomencladorIntegrador.categoria
                                },
                                {
                                    label: "Unidad de Medida",
                                    id: "periodo",
                                    customBody: (item) => item.nomencladorIntegrador.periodo
                                },
                                {
                                    label: "Dependencia",
                                    id: "dependencia",
                                    customBody: (item) => item.nomencladorIntegrador.dependencia
                                },
                                {
                                    label: "Valor",
                                    id: "valor",
                                },
                                {
                                    label: "Fecha Vigencia Desde",
                                    id: "fechaInicioVigencia",
                                    customBody: (item) => item.fechaInicioVigencia ? moment(item.fechaInicioVigencia).format('DD/MM/YYYY') : ""
                                },
                                {
                                    label: "Fecha Vigencia Hasta",
                                    id: "fechaFinVigencia",
                                    customBody: (item) => item.fechaFinVigencia ? moment(item.fechaFinVigencia).format('DD/MM/YYYY') : ""
                                },
                                {
                                    label: "",
                                    id: "",
                                    customBody: (item) => <EditConveniosButton idItem={item.idValorizacion} item={item} editItem={handleEditValorizacion} />
                                }
                            ]}
                        />
                    </Card>
                </Grid>
            </Grid>
        </>
    )
}